module.exports = __webpack_public_path__ + "img/powerpoint-slide-design.057c03f.svg";